import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const CaretUpIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 12 8" },
        React.createElement("path", { d: "M11.3533 5.79294L6.35339 0.793018C6.15813 0.597758 5.84155 0.597758 5.64628 0.793018L0.646358 5.79294C0.451097 5.9882 0.451097 6.30478 0.646358 6.50005L1.35332 7.20701C1.54858 7.40227 1.86516 7.40227 2.06043 7.20701L5.99985 3.26759L9.93927 7.20701C10.1345 7.40227 10.4511 7.40227 10.6464 7.20701L11.3533 6.50005C11.5486 6.30479 11.5486 5.98821 11.3533 5.79294Z" })));
};

export { CaretUpIcon };
//# sourceMappingURL=CaretUpIcon.esm.js.map
